export function NotConfigured() {
  return (
    <div className="grid min-h-screen place-items-center p-6">
      <div className="card max-w-md p-8">
        <h1 className="font-semibold">Not configured yet</h1>
        <p className="mt-2 text-sm text-ink-3">
          The server hasn't been given its Cognito settings, so signing in isn't
          possible. Set <code>COGNITO_USER_POOL_ID</code>,{" "}
          <code>COGNITO_WEB_CLIENT_ID</code> and <code>COGNITO_DOMAIN</code> (via
          Vault in production), then reload.
        </p>
      </div>
    </div>
  );
}
